import React, { useEffect, useState } from "react";
import { useApp } from "@/AppContext";
import api from "@/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function OrdersModal({ open, onOpenChange }) {
  const { t } = useApp();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (open) api.get("/orders").then(({ data }) => setOrders(data)).catch(() => {});
  }, [open]);

  const statusColor = (s) => ({
    pending: "text-amber-500", shipped: "text-blue-600", completed: "text-emerald-600", cancelled: "text-red-400",
  }[s] || "text-slate-500");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-white border-cyan-500/30 max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="orders-modal">
        <DialogHeader>
          <DialogTitle className="font-head text-2xl text-slate-900">{t("orders")}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          {orders.length === 0 && <p className="text-slate-500 text-sm text-center py-8">—</p>}
          {orders.map((o, i) => (
            <div key={o.id} className="ps-glow-card rounded-xl p-4" data-testid={`order-${i}`}>
              <div className="flex items-center justify-between mb-2">
                <span className="font-mono-ps text-xs text-slate-500">#{o.id.slice(-6)}</span>
                <span className={`text-xs font-bold uppercase ${statusColor(o.status)}`}>{o.status}</span>
              </div>
              <div className="text-sm text-slate-600">
                {o.items.map((it, j) => (
                  <div key={j} className="flex justify-between">
                    <span>{it.pn} · {it.name}</span>
                    <span>${Number(it.price || 0).toLocaleString()}</span>
                  </div>
                ))}
              </div>
              <div className="flex justify-between mt-2 pt-2 border-t border-slate-200">
                <span className="text-slate-500 text-sm">{t("total")}</span>
                <span className="font-display font-bold text-cyan-600">${Number(o.total).toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
